export enum Tables {
	pendings,
	inProgress,
	history
}